
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locale/whistleblowing",
      function () {
        return require("private-next-pages/locale/whistleblowing.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locale/whistleblowing"])
      });
    }
  